import kyWithSentry from './helper/kyWithSentry';
import { EntityTypes } from 'context/entityContext';
import getLinkfireTableUrl from 'url-constructors/Linkfire/getLinkfireTableURL';

export interface ILinkfireTableArgs {
  entityType: EntityTypes;
  entityIds: string[];
  tableType: 'channels' | 'stores';
}

export interface ISourceDistributionResponseObj {
  artistId: string;
  store: string;
  data: {
    visitors: number;
    visits: number;
    channel: string;
  }[];
}

const linkfireTableInterceptor = async (
  input: RequestInfo /* eslint-disable-line */,
  init: RequestInit | undefined /* eslint-disable-line */,
  interceptionData: ILinkfireTableArgs
): Promise<Response> => {
  try {
    const url = getLinkfireTableUrl(interceptionData);
    const response: ISourceDistributionResponseObj[] = await kyWithSentry
      .get(url)
      .json();
    return new Response(JSON.stringify(response));
  } catch (error) {
    const errorInfo = await error.response.json();
    return new Response(
      JSON.stringify({
        reason: {
          message: errorInfo.message,
        },
      })
    );
  }
};

export default linkfireTableInterceptor;
